export type LocalizedNameParts = {
  japanese: string;
  english: string;
};

export function splitLocalizedName(name?: string | null): LocalizedNameParts {
  if (!name) {
    return { japanese: '', english: '' };
  }

  const [japanese = '', english = ''] = name.split('$');

  return {
    japanese: japanese.trim(),
    english: english.trim(),
  };
}
